import {FC} from 'react'
import {DictionarySelector, DictionarySelectorProps} from 'common/components/dictionary/DictionarySelector.tsx'
import {ownedByValues} from 'common/api/dictionaries.tsx'

export const OwnedBySelector: FC<DictionarySelectorProps> = (props) =>
    <DictionarySelector {...props} cacheKey="ownedBy"
                        loader={() => Promise.resolve(ownedByValues)}
    />